// Wyndham Collection Product Finder tracking configuration.
window.WC_PRODUCT_FINDER_TRACKING_URL = 'https://script.google.com/macros/s/AKfycbw1YAwf_Q3EjURxcjsw0cLhBxxPgYne6nnjTzSSe46l6SmeR-f8Aog8u3yaSdEKnniQ8w/exec';
window.WC_PRODUCT_FINDER_TRACKING_KEY = 'WC_PF_2026_p0iVGsX7XRKav21xiIfiekQk3j8gBffj';
